import { makeAutoObservable } from 'mobx'
import { restClient } from '@/Core'
import type { Notify } from '@/Ship/Contracts/Notify'

/**
 * Local store of `SendPushModal`.
 * Owns push message text, submission flag, and the send-push request.
 * Instantiated per modal mount via `useState(() => new SendPushModalStore())`.
 */
export class SendPushModalStore {
    message = ''
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setMessage(v: string): void {
        this.message = v
    }

    setLoading(v: boolean): void {
        this.loading = v
    }

    reset(): void {
        this.message = ''
    }

    async send(assignmentUuid: string, notify: Notify): Promise<boolean> {
        this.setLoading(true)
        try {
            await restClient.post(`/services/executor-assignments/${assignmentUuid}/send-push`, {
                json: { message: this.message },
            })
            notify.success('Push-повідомлення надіслано')
            this.reset()
            return true
        } catch {
            notify.error('Помилка надсилання push-повідомлення')
            return false
        } finally {
            this.setLoading(false)
        }
    }
}
